<script setup lang="ts">
import { inject, onMounted, ref, watch } from 'vue'

import { config } from '@/lib/helpers'
import { previewDataProvideFlag } from '@/lib/hooks/provider.hooks'
import type { ReturnAdPreviewType } from '@/lib/types/return-ad.types'
import { BoxComponent, FlexComponent, LoadingComponent } from '@/ui-library'

const iframeRef = ref<HTMLIFrameElement | null>(null)
const iframeSrc = ref(config.linkRedirectServiceUrl)
const previewData = inject(previewDataProvideFlag)
const isLoading = ref(true)

const sendDataToIframe = (data?: ReturnAdPreviewType) => {
  if (iframeRef.value?.contentWindow && data) {
    const value = JSON.parse(JSON.stringify(data))
    isLoading.value = false
    iframeRef.value.contentWindow.postMessage({ type: 'RETURN_AD_PREVIEW_DATA', value }, iframeSrc.value)
  }
}
onMounted(() => {
  if (iframeRef.value) {
    iframeRef.value.addEventListener('load', () => sendDataToIframe(previewData?.valueRef?.value))
  }
})
watch(
  () => previewData?.valueRef?.value,
  (newValue) => sendDataToIframe(newValue),
)
</script>
<template>
  <FlexComponent justify="center" :gap="24" class="return-ad-preview__frame-wrapper">
    <div class="return-ad-preview__frame-container">
      <BoxComponent v-if="isLoading" h="100%" class="return-ad-preview__loading-container">
        <LoadingComponent :size="64" />
      </BoxComponent>
      <iframe
        ref="iframeRef"
        class="return-ad-preview__iframe"
        :src="`${iframeSrc}/return-ads/preview`"
        width="100%"
        height="100%"
        referrerpolicy="no-referrer"
      ></iframe>
    </div>
  </FlexComponent>
</template>
<style lang="scss" scoped>
.return-ad-preview__loading-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: var(--inverted);
}
.return-ad-preview__frame-wrapper {
  height: 100%;
  position: relative;
}

.return-ad-preview__frame-container {
  overflow: hidden;
  width: 360px;
  height: 780px;
  border: 16px solid #222;
  border-radius: 24px;
  background: #fff;
  isolation: isolate;

  transform: scale(1);
  transform-origin: center top;
  position: sticky;
  top: 96px;

  @media (max-height: 768px) {
    transform: scale(0.65);
  }
}
.return-ad-preview__iframe {
  border: none;
}
</style>
